import { ValueOf } from 'shared/types/generic'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

export const CardMode = {
  available: 'available',
  unavailable: 'unavailable',
  used: 'used'
} as const

export const CardActiveState = {
  active: 'active',
  disabled: 'disabled',
  none: 'none'
} as const

export type CardMode = ValueOf<typeof CardMode>
export type CardActiveState = ValueOf<typeof CardActiveState>

export const determineRebateCardMode = (
  isAvailable: boolean,
  isUsed: boolean
): CardMode => {
  if (isAvailable) return CardMode.available
  if (isUsed) return CardMode.used

  return CardMode.unavailable
}

export const determineRebateCardActiveState = (
  activeIDs: string[],
  rebateID: string
): CardActiveState => {
  if (activeIDs.includes(rebateID)) return CardActiveState.active
  if (isNotNilOrEmpty(activeIDs)) return CardActiveState.disabled

  return CardActiveState.none
}
